export default __webpack_public_path__ + "static/media/photo--lg--46.6f390810.jpg";